<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw==" crossorigin="anonymous" referrerpolicy="no-referrer" />

<div class="document-tracking-container">
  <div class="header">
    <h2>Document Tracking</h2>
    <div class="action-buttons">
 
      <button class="btn btn-primary me-2" (click)="addNewDocument()">Add Document</button>
      
    </div>
  </div>

  <div class="filters-section">
    <div class="row">
      <div class="col-md-3">
        <label for="employeeFilter">Filter by Employee</label>
        <select id="employeeFilter" class="form-control" [(ngModel)]="selectedEmployee" (change)="applyFilters()">
          <option [ngValue]="null">All Employees</option>
          <option *ngFor="let employee of employees$ | async" [ngValue]="employee.id">
            {{ employee.name }}
          </option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="statusFilter">Filter by Status</label>
        <select id="statusFilter" class="form-control" [(ngModel)]="selectedStatus" (change)="applyFilters()">
          <option value="">All Statuses</option>
          <option *ngFor="let status of documentStatuses" [value]="status">
            {{ status | titlecase }}
          </option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="typeFilter">Filter by Type</label>
        <select id="typeFilter" class="form-control" [(ngModel)]="selectedType" (change)="applyFilters()">
          <option value="">All Types</option>
          <option *ngFor="let type of documentTypes$ | async" [value]="type.name" [class.text-muted]="type.status !== 1">
            {{ type.name | titlecase }}
          </option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="searchFilter">Search</label>
        <input
          id="searchFilter"
          type="text"
          class="form-control"
          placeholder="Search documents..."
          [(ngModel)]="searchTerm"
          (input)="applyFilters()">
      </div>
    </div>

    <div class="mt-2">
      <button class="btn btn-secondary" (click)="resetFilters()">Reset Filters</button>
    </div>
  </div>

  <div class="document-list mt-4">
    <ng-container *ngIf="filteredDocuments$ | async as documents">
      <div *ngIf="documents.length > 0; else noDocuments">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Id</th>
                <th>Title</th>
                <th>Employee</th>
                <th>Type</th>
                <th>Status</th>
                <th>Issue Date</th>
                <th>Expiry Date</th>
                <th>Document URL</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let document of documents">
                <td>{{ document.id }}</td>
                <td>{{ document.title }}</td>
                <td>
                  <ng-container *ngIf="document.employeeId && (employees$ | async) as employees">
                    {{ (employees | filter: { id: document.employeeId })[0]?.name || 'Unknown' }}
                  </ng-container>
                </td>
                <td>
                  <span [class.text-primary]="isCV(document)">
                    {{ document.documentType }}
                    <!-- Show CV analysis status badge if this is a CV -->
                    <span *ngIf="isCV(document)" 
                          [class]="getCVStatusClass(document.cv_analysis_status)"
                          [title]="'CV Analysis: ' + getCVStatusLabel(document.cv_analysis_status)">
                      {{ getCVStatusLabel(document.cv_analysis_status) }}
                    </span>
                  </span>
                </td>
                <td>
                  <span [ngClass]="{
                    'badge bg-success': document.status === 'valid',
                    'badge bg-warning': document.status === 'expiring',
                    'badge bg-danger': document.status === 'expired',
                    'badge bg-secondary': document.status === 'missing'
                  }">
                    {{ document.status | titlecase }}
                  </span>
                </td>
                <td>{{ document.issueDate | date }}</td>
                <td>{{ document.expiryDate | date }}</td>
                <td>      
                  <button class="btn btn-sm btn-outline-info" *ngIf="document.file_path" (click)="viewDocument(document.file_path)" aria-label="View document">
                  <i class="fas fa-file-pdf"></i>
                </button>
              </td>
                <td>
                  <div class="btn-group">
                    <button class="btn btn-sm btn-outline-primary" (click)="editDocument(document)" aria-label="Edit document">
                      <i class="fas fa-edit"></i>
                    </button>
                    <!-- Special actions for CV documents -->
                    <ng-container *ngIf="isCV(document)">
                      <button class="btn btn-sm btn-outline-info" (click)="viewCVSummary(document)" 
                              [disabled]="document.cv_analysis_status !== 'completed'"
                              aria-label="View CV summary">
                        <i class="fas fa-file-alt" title="View CV Summary"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-warning" (click)="reanalyzeCVDocument(document.id)"
                              *ngIf="document.cv_analysis_status === 'failed' || document.cv_analysis_status === 'completed'"
                              aria-label="Reanalyze CV">
                        <i class="fas fa-sync-alt" title="Reanalyze CV"></i>
                      </button>
                    </ng-container>
                    <button class="btn btn-sm btn-outline-danger" (click)="deleteDocument(document)" aria-label="Delete document">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template #noDocuments>
        <div class="alert alert-info">
          No documents found. Try adjusting your filters or add a new document.
        </div>
      </ng-template>
    </ng-container>
  </div>

  <!-- Document Form Modal -->
  <div *ngIf="showDocumentModal" class="modal-container">
    <!-- Backdrop - prevent click events from propagating through modal content to backdrop -->
    <div class="modal-backdrop" (click)="closeDocumentModal()"></div>
    
    <!-- Modal dialog - stop click propagation to prevent backdrop click handler -->
    <div class="modal-dialog modal-lg" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ editingDocument ? 'Edit Document' : 'Add New Document' }}</h5>
          <button type="button" class="close-btn" (click)="closeDocumentModal()" aria-label="Close">
            Close
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="documentForm">
            <div class="row">
              <div class="col-md-6 form-group">
                <label for="title">Title</label>
                <input
                  id="title"
                  type="text"
                  class="form-control"
                  formControlName="title"
                  placeholder="Document Title"
                  required>
                <div *ngIf="documentForm.get('title')?.invalid && documentForm.get('title')?.touched" class="text-danger">
                  Title is required.
                </div>
              </div>

              <div class="col-md-6 form-group">
                <label for="employeeId">Employee</label>
                <select
                  id="employeeId"
                  class="form-control"
                  formControlName="employeeId"
                  required>
                  <option [ngValue]="null">Select Employee</option>
                  <option *ngFor="let employee of employees$ | async" [ngValue]="employee.id">
                    {{ employee.name }}
                  </option>
                </select>
                <div *ngIf="documentForm.get('employeeId')?.invalid && documentForm.get('employeeId')?.touched" class="text-danger">
                  Employee is required.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 form-group">
                <label for="documentType">Document Type</label>
                <select
                  id="documentType"
                  class="form-control"
                  formControlName="documentType"
                  required>
                  <option value="">Select Type</option>
                  <option *ngFor="let type of documentTypes$ | async" [value]="type.name" [class.text-muted]="type.status !== 1">
                    {{ type.name | titlecase }}
                  </option>
                </select>
                <div *ngIf="documentForm.get('documentType')?.invalid && documentForm.get('documentType')?.touched" class="text-danger">
                  Document type is required.
                </div>
              </div>

              <div class="col-md-4 form-group">
                <label for="issueDate">Issue Date</label>
                <input
                  id="issueDate"
                  type="date"
                  class="form-control"
                  formControlName="issueDate"
                  required>
                <div *ngIf="documentForm.get('issueDate')?.invalid && documentForm.get('issueDate')?.touched" class="text-danger">
                  Issue date is required.
                </div>
              </div>

              <div class="col-md-4 form-group">
                <label for="expiryDate">Expiry Date</label>
                <input
                  id="expiryDate"
                  type="date"
                  class="form-control"
                  formControlName="expiryDate"
                  required>
                <div *ngIf="documentForm.get('expiryDate')?.invalid && documentForm.get('expiryDate')?.touched" class="text-danger">
                  Expiry date is required.
                </div>
              </div>
            </div>

            <div class="form-group mt-3">
              <label for="document_file">Document Files (PDF or DOCX only, max 10MB each)</label>
              <div class="custom-file-input-wrapper">
                <input
                  id="document_file"
                  type="file"
                  class="form-control"
                  accept=".pdf,.docx"
                  multiple
                  (change)="onDocumentFilesSelected($event)">
              </div>
              <div *ngIf="documentUploadError" class="text-danger mt-1">
                {{ documentUploadError }}
              </div>
              <div *ngIf="selectedDocumentFiles && selectedDocumentFiles.length > 0" class="mt-2">
                <p>Selected files ({{ selectedDocumentFiles.length }}):</p>
                <ul class="list-group">
                  <li *ngFor="let file of selectedDocumentFiles" class="list-group-item d-flex justify-content-between align-items-center">
                    {{ file.name }} ({{ (file.size / 1024).toFixed(1) }} KB)
                    <button class="btn btn-sm btn-danger" (click)="removeSelectedFile(file)" aria-label="Remove file" title="Remove file">
                      <i class="fas fa-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="form-group" *ngIf="editingDocument">
              <label for="documentUrl">Document URL(readonly)</label>
              <div class="input-group">
                <input
                  id="documentUrl"
                  type="text"
                  class="form-control"
                  formControlName="documentUrl"
                  placeholder="Link to document"
                  readonly>
                <button class="btn btn-outline-primary" type="button" *ngIf="documentForm.get('documentUrl')?.value" (click)="viewDocument(documentForm.get('documentUrl')?.value)">
                  <i class="fas fa-file-pdf"></i>
                </button>
              </div>
            </div>

            <div class="form-group">
              <label for="notes">Notes (optional)</label>
              <textarea
                id="notes"
                class="form-control"
                formControlName="notes"
                rows="3"
                placeholder="Additional notes"></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="documentForm.invalid" (click)="saveDocument()">
            {{ editingDocument ? 'Update' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- CV Upload Modal -->
  <div class="modal" [class.show]="showCVUploadModal" [style.display]="showCVUploadModal ? 'block' : 'none'">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload CV Document</h5>
          <button type="button" class="btn-close" (click)="closeCVUploadModal()" aria-label="Close CV upload modal"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="cvUploadForm" (ngSubmit)="uploadCV()">
            <div class="row">
              <div class="col-md-6 form-group">
                <label for="title">Title</label>
                <input
                  id="title"
                  type="text"
                  class="form-control"
                  formControlName="title"
                  placeholder="CV Document Title"
                  required>
                <div *ngIf="cvUploadForm.get('title')?.invalid && cvUploadForm.get('title')?.touched" class="text-danger">
                  Title is required.
                </div>
              </div>

              <div class="col-md-6 form-group">
                <label for="employeeId">Employee</label>
                <select
                  id="employeeId"
                  class="form-control"
                  formControlName="employeeId"
                  required>
                  <option [ngValue]="null">Select Employee</option>
                  <option *ngFor="let employee of employees$ | async" [ngValue]="employee.id">
                    {{ employee.name }}
                  </option>
                </select>
                <div *ngIf="cvUploadForm.get('employeeId')?.invalid && cvUploadForm.get('employeeId')?.touched" class="text-danger">
                  Employee is required.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label for="issueDate">Issue Date</label>
                <input
                  id="issueDate"
                  type="date"
                  class="form-control"
                  formControlName="issueDate"
                  required>
                <div *ngIf="cvUploadForm.get('issueDate')?.invalid && cvUploadForm.get('issueDate')?.touched" class="text-danger">
                  Issue date is required.
                </div>
              </div>

              <div class="col-md-6 form-group">
                <label for="cv_file">CV File (PDF or DOCX only, max 10MB)</label>
                <div class="custom-file-input-wrapper">
                  <input
                    id="cv_file"
                    type="file"
                    class="form-control"
                    accept=".pdf,.docx"
                    (change)="onFileSelected($event)">
                </div>
                <div *ngIf="!selectedFile && cvUploadForm.touched" class="text-danger mt-1">
                  Please select a CV file.
                </div>
                <div *ngIf="uploadError" class="text-danger mt-1">
                  {{ uploadError }}
                </div>
                <div *ngIf="selectedFile" class="mt-1 text-success">
                  <i class="fas fa-check-circle"></i> 
                  {{ selectedFile.name }} ({{ (selectedFile.size / 1024).toFixed(1) }} KB)
                </div>
              </div>
            </div>

            <div class="alert alert-info mt-3">
              <i class="fas fa-info-circle me-2"></i>
              The CV will be analyzed using AI to extract key information such as education, experience, skills, and achievements.
            </div>
            
            <!-- Debug form validation status -->
            <div class="debug-info mt-3 p-2 bg-light border">
              <h6>Form Status:</h6>
              <ul class="mb-0">
                <li>Form Valid: {{ !cvUploadForm.invalid }}</li>
                <li>File Selected: {{ !!selectedFile }}</li>
                <li>Uploading: {{ isUploading }}</li>
                <li>Title Valid: {{ cvUploadForm.get('title')?.valid }}</li>
                <li>Employee ID Valid: {{ cvUploadForm.get('employeeId')?.valid }}</li>
                <li>Issue Date Valid: {{ cvUploadForm.get('issueDate')?.valid }}</li>
              </ul>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cvUploadForm.markAllAsTouched(); cvUploadForm.updateValueAndValidity()">
                  Trigger Form Validation
                </button>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" (click)="closeCVUploadModal()">Cancel</button>
              
              
              
              <!-- Original button -->
              <button 
                type="submit" 
                class="btn btn-primary ms-2" 
                [disabled]="cvUploadForm.invalid || !selectedFile || isUploading">
                <span *ngIf="isUploading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {{ isUploading ? 'Uploading...' : 'Upload & Analyze CV' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- CV Summary Modal -->
  <div class="modal" [class.show]="showCVSummaryModal" [style.display]="showCVSummaryModal ? 'block' : 'none'">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">CV Summary</h5>
          <button type="button" class="btn-close" (click)="closeCVSummaryModal()" aria-label="Close CV summary modal"></button>
        </div>
        <div class="modal-body" *ngIf="currentCVSummary">
          <h5>{{ currentCVSummary.title }}</h5>
          
          <div class="mb-3">
            <span [ngClass]="getCVStatusClass(currentCVSummary.status)">
              {{ getCVStatusLabel(currentCVSummary.status) }}
            </span>
            <span *ngIf="currentCVSummary.analysisDate" class="ms-2 text-muted">
              Analyzed on {{ currentCVSummary.analysisDate | date:'medium' }}
            </span>
          </div>

          <div class="cv-summary-content p-3 border rounded bg-light">
            <div *ngIf="currentCVSummary.status === 'completed'; else loadingOrFailed">
              <div [innerHTML]="currentCVSummary.summary | linky"></div>
            </div>
            <ng-template #loadingOrFailed>
              <div *ngIf="currentCVSummary.status === 'pending' || currentCVSummary.status === 'processing'" class="text-center p-3">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2">CV analysis is still in progress. Please check back later.</p>
              </div>
              <div *ngIf="currentCVSummary.status === 'failed'" class="text-center p-3">
                <div class="alert alert-danger">
                  <i class="fas fa-exclamation-triangle me-2"></i>
                  CV analysis failed. Please try to reanalyze the document.
                </div>
                <button class="btn btn-warning mt-2" (click)="reanalyzeCVDocument(currentCVSummary.id)">
                  <i class="fas fa-sync-alt me-1"></i>
                  Reanalyze CV
                </button>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeCVSummaryModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
